"use client"

interface ConnectionBadgeProps {
  isConnected: boolean
}

export function ConnectionBadge({ isConnected }: ConnectionBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold font-mono uppercase tracking-wider border ${
        isConnected
          ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/25"
          : "bg-red-500/15 text-red-400 border-red-500/25"
      }`}
    >
      <span
        className={`size-1.5 rounded-full shrink-0 ${
          isConnected ? "bg-emerald-400 animate-pulse" : "bg-red-400"
        }`}
      />
      {isConnected ? "Live" : "Offline"}
    </span>
  )
}
